import '../shared/nav/collapsing_nav'
import '../shared/phone'

import AddToCartForms from '../shared/add_to_cart_forms'
import CartNav from '../shared/nav/nav_cart'
import Checkout from '../shared/checkout'
import PackageTabs from '../shared/package_tabs'

document.addEventListener('turbolinks:load', () => {
  AddToCartForms.loadBottomForm()
  CartNav.addCartToNavbar()
  Checkout.loadWithAddOn()
  PackageTabs.loadTabs(769)
})
